import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import HttpRunner from '../query';
import examples from '../../../utils/examples';
import perms from '../../../utils/permissions';
import urlHandler from '../../../utils/urlHandler';

class DocV1Version extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_VERSION),
        })
    }

    render() {
        return (
            <div className="bucket" id="top">
                <span id="sysinfo_endpoint">
                    <span className='heading-1'>Version</span>
                </span>
                <code className="api-definition">
                    <span className="get-badge">GET</span>&nbsp;{urlHandler.API_ENDPOINT_V1_VERSION}?{'{'}query parameters{'}'}
                </code>
                <div className="description">
                    Returns package version and revision information related to the current release. Historical 
                    package information is available as well.
                </div>

                <h4 className="heading-2">Request</h4>
                <div className="heading-3">Query Parameters</div>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">history</td>
                        <td className="meaning">True to return package information for prior releases.</td>
                        <td className="type">Boolean</td>
                        <td className="type">Optional.<br/>
                            Default: False
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2">Response</h4>
                <div className="description">
                    The response object contains the package information.
                </div>

                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">current</td>
                        <td className="meaning">Package information for the current release.
                        </td>
                        <td className="type">JSON Object. See <a href="#package_object">Package Information</a>.</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">history</td>
                        <td className="meaning">Array of package information for past releases.
                        </td>
                        <td className="type">JSON Array. See <a href="#package_object">Package Information</a>.</td>
                        <td className="type">Optional.<br/>
                            <br/>
                            Only available if <i>history</i> parameter is <i>True</i> in request.
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3" id="package_object">Package Information</h4>
                <div className="description">
                    Object that contains information for a particular package.
                </div>

                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">package</td>
                        <td className="meaning">Version of the package.
                        </td>
                        <td className="type">Integer</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">revisions</td>
                        <td className="meaning">An array of revisions or changes contained in the package.
                        </td>
                        <td className="type">[String]</td>
                        <td className="type">Optional.</td>
                    </tr>
                    </tbody>
                </table>

                <div className="heading-2">Example</div>
                <div className="example-content host">
                    <pre>
                        GET {urlHandler.API_ENDPOINT_V1_VERSION}<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                    </pre>
                </div>

                <HttpRunner query="version" 
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_V1_VERSION) : null}
                />
            </div>
        );
    }
}

export default DocV1Version;